<template lang="pug">
  div.aside-user-nav
    div.nav(v-for="n in navigators" :key="n.key" :class="{active: n.key === $route.name}" @click.prevent="toRoute(n.key)") {{n.name}}
      div.bottom
</template>

<script>
import { navigators } from '@index/config/config'
export default {
  name: 'AsideUserNav',
  data () {
    return {
      navigators: navigators
    }
  },
  methods: {
    toRoute (key) {
      this.$router.replace({
        name: key
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .aside-user-nav{
    padding: 24px;
    display: flex;
    align-items: center;
    .nav{
      color: #333;
      cursor: pointer;
      position: relative;
      margin-right: 50px;
      .bottom{
        width: 30px;
        height: 2px;
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translate(-50%, 0);
        background-color: #fff;
      }
      &.active .bottom{
        background-color: #3989cb;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/UserCenter/AsideUserNav.vue